import { render, staticRenderFns } from "./MessageByFlowWidget.vue?vue&type=template&id=6c9c84ec&scoped=true&"
import script from "./MessageByFlowWidget.vue?vue&type=script&lang=js&"
export * from "./MessageByFlowWidget.vue?vue&type=script&lang=js&"
import style0 from "./MessageByFlowWidget.vue?vue&type=style&index=0&id=6c9c84ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9c84ec",
  null
  
)

export default component.exports